import ratings from "../phab-ratings";

document.addEventListener("turbolinks:load", function () {
    ratings();
});

import "raty-js/lib/jquery.raty.css";